import React from 'react'
import Badge, { BadgeProps } from "@mui/material/Badge"
import { styled } from "@mui/material/styles"
import Avatar from '@mui/material/Avatar'

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  backgroundColor: 'whitesmoke',
  borderRadius: '50%',
  '& .MuiBadge-badge': {
    border: `2px solid ${(theme.vars ?? theme).palette.background.paper}`,
    height: '12px',
    width: '12px',
    borderRadius: '50%',
  },
}))

const fallbackInitials = (name: string | undefined) => {
  if (name) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`.toUpperCase()
    };
  }
}

const stringToColor = (string: string): React.CSSProperties['color'] => {
  let hash = 0;
  let i: number;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

type Props = {
  imageUrl?: string
  fallbackText?: string
  offline?: boolean
}

const AvatarWithDotStatus: React.FC<Props> = ({ imageUrl, fallbackText, offline }) => {
  return (
    <StyledBadge
      color="success"
      variant="dot"
      invisible={offline}
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    > 
      <Avatar src={imageUrl} {...fallbackInitials(fallbackText)} sx={{ opacity: offline ? 0.5 : 1 }} />
    </StyledBadge>
  )
}

export default AvatarWithDotStatus
